// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"c2869a11","513":"75e873d8"}[chunkId] + ".chunk.css";
};